import { useEffect, useState, useMemo } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import api from "@/lib/api";
import { MapPin } from "lucide-react";

const pinIcon = L.divIcon({ className: "", html: '<div class="gig-pin"></div>', iconSize: [16, 16], iconAnchor: [8, 8] });

export default function MapPage() {
  const [posters, setPosters] = useState([]);

  useEffect(() => {
    api.get("/posters").then((r) => setPosters(r.data));
  }, []);

  const groups = useMemo(() => {
    const map = {};
    posters.forEach((p) => {
      if (p.lat != null && p.lng != null) {
        const key = `${p.lat},${p.lng}`;
        if (!map[key]) map[key] = { lat: p.lat, lng: p.lng, city: p.venue_city, items: [] };
        map[key].items.push(p);
      }
    });
    return Object.values(map);
  }, [posters]);

  const mappable = groups.length;

  return (
    <div className="p-6 lg:p-10 max-w-7xl">
      <div className="mb-6">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-acid">Concert Geography</div>
        <h1 className="font-display text-5xl lg:text-6xl text-paper leading-none mt-1">GIG MAP</h1>
        <div className="font-mono text-xs text-muted-gray mt-2">
          {mappable} venue{mappable !== 1 ? "s" : ""} pinned · {posters.length} posters total
        </div>
      </div>

      {posters.length === 0 ? (
        <div className="border border-dashed border-stroke p-12 text-center font-mono text-sm text-muted-gray">
          Add posters with a city to map your concert history.
        </div>
      ) : (
        <div className="border border-stroke" data-testid="gig-map" style={{ height: "70vh" }}>
          <MapContainer center={mappable ? [groups[0].lat, groups[0].lng] : [39.5, -98.35]}
            zoom={mappable ? 4 : 3} style={{ height: "100%", width: "100%" }} scrollWheelZoom>
            <TileLayer
              attribution='&copy; OpenStreetMap contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {groups.map((g) => (
              <Marker key={`${g.lat},${g.lng}`} position={[g.lat, g.lng]} icon={pinIcon}>
                <Popup>
                  <div className="font-mono">
                    <div className="text-xs uppercase tracking-widest text-emerald-600 mb-1 flex items-center gap-1">
                      <MapPin size={12} /> {g.city}
                    </div>
                    {g.items.map((p) => (
                      <div key={p.id} className="text-sm border-t border-stroke/40 py-1">
                        <span className="font-bold">{p.band}</span> — {p.title}
                        {p.show_date && <span className="block text-[10px] opacity-70">{p.show_date}</span>}
                      </div>
                    ))}
                  </div>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>
      )}
    </div>
  );
}
